import { LexicalNode, createCommand, LexicalCommand } from 'lexical';
import { TextMatchTransformer } from '@lexical/markdown';
import { User } from '@certhon/models';
import {
  MentionNode,
  $createMentionNode,
} from '@/components/editor/MentionPlugin/MentionNode';

export function $isMentionNode(
  node: LexicalNode | null | undefined,
): node is MentionNode {
  return node instanceof MentionNode;
}

export const MENTION_TRANSFORMER: TextMatchTransformer = {
  dependencies: [MentionNode],
  export: (node) => {
    if (!$isMentionNode(node)) {
      return null;
    }
    return `@${node.getMentionName()}`;
  },
  importRegExp: /@([a-zA-Z0-9_]+(?:\.[a-zA-Z0-9_]+)*)/,
  regExp: /@([a-zA-Z0-9_]+(?:\.[a-zA-Z0-9_]+)*)$/,
  replace: (textNode, match) => {
    const [, mentionName] = match;
    const mentionNode = $createMentionNode(mentionName);
    textNode.replace(mentionNode);
  },
  trigger: '@',
  type: 'text-match',
};

export const INSERT_USER_COMMAND: LexicalCommand<User> = createCommand(
  'INSERT_USER_COMMAND',
);
